import { makeRequest } from './index';

export async function getAddressByViaCEP(cep) {
  // const route = `https://viacep.com.br/ws/${cep}/json/`;
  // return await anotherDomain("GET", route);
  return await makeRequest('GET', `/buscarcep/${cep}`);
}

export async function getTypeProtocol() {
  return await makeRequest('GET', 'type_protocol_filters');
}

export async function getAddressByServer(cep) {
  return await makeRequest('GET', `/access_service_viacep/buscarcep/${cep}`);
}

export async function getCountiesOfBahia() {
  return await makeRequest('GET', 'domain_table/get/countiesOfBahia');
}

export async function getHeathRegions() {
  return await makeRequest('GET', 'domain_table/get/heathRegions');
}

export async function getMacroregions() {
  return await makeRequest('GET', 'domain_table/get/macroregions');
}

export async function getStatus() {
  return await makeRequest('GET', 'deleted_filters');
}

export async function getGenders() {
  return await makeRequest('GET', 'aghuse_sexes');
}

export async function getColors() {
  return await makeRequest('GET', 'aghuse_colors');
}

export async function getCivilStatus() {
  return await makeRequest('GET', 'aghuse_civil_statuses');
}

export async function getNationalities() {
  return await makeRequest('GET', 'aghuse_nationalities');
}

export async function getNaturalitiesInAGHUSE() {
  return await makeRequest('GET', 'aghuse_birthplaces');
}

export async function getEducationDegrees() {
  return await makeRequest('GET', 'aghuse_instruction_degrees');
}

export async function getOccupationsInAGHUSE() {
  return await makeRequest('GET', 'aghuse_occupations');
}

export async function getAddressByCepInAGHUSE(cep) {
  return await makeRequest('GET', 'access_service_aghuse/1/filter', null, {
    endPointFilter: 'enderecos',
    cep: cep,
  });
}

export async function getAddressTypes() {
  return await makeRequest('GET', 'aghuse_type_addresses');
}

export async function getIssuingAuthorityInAGHUSE() {
  return await makeRequest('GET', 'aghuse_issuing_authorities');
}

export async function getUfsInAGHUSE() {
  return await makeRequest('GET', '/ufs');
}

export async function getEthnicities() {
  return await makeRequest('GET', 'aghuse_ethnicities');
}

export async function getCertificateTypes() {
  return await makeRequest('GET', 'aghuse_type_certificates');
}

export async function getProcedures() {
  return await makeRequest('GET', 'access_service_sigtap/procedure');
}

export async function getProceduresWithFilter(filter) {
  return await makeRequest('GET', 'access_service_sigtap', null, filter);
}

export async function getFilteredProcedures() {
  const filter = { filter: 'procedure' };
  return await makeRequest('GET', 'unity_ocupation_procedures', null, filter);
}

export async function getOccupationsByProcedure(procedureNumber) {
  return await makeRequest(
    'GET',
    `access_service_sigtap/procedure/${procedureNumber}`,
  );
}

export async function getFilteredOccupations(procedureNumber) {
  const filter = { co_procedure: procedureNumber };
  return await makeRequest('GET', 'unity_ocupation_procedures', null, filter);
}

export async function getSubOccupations(procedureNumber, occupationNumber) {
  return await makeRequest(
    'GET',
    `access_service_sigtap/procedure/${procedureNumber}/occupation/${occupationNumber}`,
  );
}

export async function getYesOrNo() {
  return await makeRequest('GET', 'yesno');
}

export async function getGenderIdentity() {
  return await makeRequest('GET', 'sexs');
}

export async function getYears() {
  return await makeRequest('GET', 'years');
}

export async function getMonths() {
  return await makeRequest('GET', 'months');
}

export async function getDays() {
  return await makeRequest('GET', 'days');
}

export async function getProtocolOncology(co_occupation) {
  return await makeRequest(
    'GET',
    `/protocol_oncology_data/buscarprotocols/${co_occupation}`,
  );
}

export async function getAllOccupations() {
  return await makeRequest('GET', 'access_service_sigtap/occupation');
}

export async function getSubOccupationsByOccupation(occupationCode) {
  return await makeRequest(
    'GET',
    `access_service_sigtap/occupation/${occupationCode}`,
  );
}

export async function getExams() {
  return await makeRequest('GET', 'procedures');
}

export async function getExamsProtocols() {
  return await makeRequest('GET', 'protocols_ppp_images');
}

export async function getCoords() {
  return await makeRequest('GET', 'county_lat_lon');
}

export async function getHealthDistricts() {
  return await makeRequest('GET', 'districts');
}

export async function getHealthDistrictsNeighborhoods() {
  return await makeRequest('GET', 'districts/sub/group');
}

export async function getFilteredOncologyProcedures() {
  const filter = { filter: 'procedure' };
  return await makeRequest(
    'GET',
    'unity_ocupation_procedures_oncology',
    null,
    filter,
  );
}

export async function getFilteredOncologyOccupations(procedureNumber) {
  const filter = { co_procedure: procedureNumber };
  return await makeRequest(
    'GET',
    'unity_ocupation_procedures_oncology',
    null,
    filter,
  );
}

export async function getFilteredEgressProcedures() {
  const filter = { filter: 'procedure' };
  return await makeRequest(
    'GET',
    'unity_ocupation_procedures_egress',
    null,
    filter,
  );
}

export async function getFilteredEgressOccupations(procedureNumber) {
  const filter = { co_procedure: procedureNumber };
  return await makeRequest(
    'GET',
    'unity_ocupation_procedures_egress',
    null,
    filter,
  );
}

export async function getAges() {
  return await makeRequest('GET', 'age_groups');
}

export async function getCidsByCodeProcedure(code_procedure) {
  return await makeRequest(
    'GET',
    `access_service_sigtap/cids/${code_procedure}`,
  );
}

export async function getTreatments() {
  return await makeRequest('GET', 'treatments');
}

export async function getAllCids() {
  return await makeRequest('GET', 'access_service_sigtap/cids');
}

export async function getGenderIdentities() {
  return await makeRequest('GET', 'gender_identities');
}

export async function getAttendanceRestrictionReasons() {
  return await makeRequest('GET', 'attendance_restrictions');
}
